/* eslint-disable @typescript-eslint/no-explicit-any */
import { RightOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import { ReactNode, useState } from 'react';

import { Attachments } from '../Attachments';
import { FolderName } from '../FolderName';
import { MaterialSorter } from '../MaterialSorter';

import { Wrapper } from './FolderTree.styles';

import { SortableProvider } from '@/components/SortableProvider';
import { Box } from '@/components/Utils';
import { useLocalCourse, useProfile } from '@/store';

export const FolderTree = () => {
  const { course, reorderCourseFolders } = useLocalCourse();
  const {
    roleCheck: { isManager }
  } = useProfile();
  const [currentFolderId, setCurrentFolderId] = useState<string>();

  if (!course) return null;

  const onReorder = (items: ReactNode[]) => {
    const newFoldersOrder = items.map(item => (item as any).props._id);
    reorderCourseFolders({ courseId: course._id, newFoldersOrder });
  };

  return (
    <Wrapper>
      <SortableProvider
        zIndex={10}
        droppableId="folders"
        onReorder={onReorder}
        isDragDisabled={!!currentFolderId || !isManager}>
        {course.foldersWithMaterial.map(folder => (
          <Collapse
            key={folder._id}
            accordion
            {...folder}
            activeKey={currentFolderId}
            onChange={key => setCurrentFolderId(key[0])}
            expandIcon={({ isActive }) => (
              <Box gap={10}>
                <RightOutlined rotate={isActive ? 90 : 0} />
              </Box>
            )}>
            <Collapse.Panel
              key={folder._id}
              header={<FolderName folder={folder} />}
              extra={
                isManager && (
                  <div onClick={e => e?.stopPropagation()}>
                    <Attachments folder={folder} />
                  </div>
                )
              }>
              {folder.material && <MaterialSorter folder={folder} />}
            </Collapse.Panel>
          </Collapse>
        ))}
      </SortableProvider>
    </Wrapper>
  );
};
